"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRenderingTextField = isRenderingTextField;
exports.isRenderingRadioField = isRenderingRadioField;
exports.isRenderingCheckboxGroupField = isRenderingCheckboxGroupField;
exports.isRenderingAgreeField = isRenderingAgreeField;
exports.isRenderingButtonField = isRenderingButtonField;
exports.isRenderingAutocompleteField = isRenderingAutocompleteField;
exports.isRenderingPlaceholderField = isRenderingPlaceholderField;
exports.isRenderingOptionField = isRenderingOptionField;
exports.isRenderingRepeatedSectionGroup = isRenderingRepeatedSectionGroup;
exports.isRenderingRepeatedFieldGroup = isRenderingRepeatedFieldGroup;
exports.isRenderingInformationField = isRenderingInformationField;
const lodash_1 = __importDefault(require("lodash"));
const fieldTypes_1 = require("../../types/carrierQuestionnaire/fieldTypes");
const structure_1 = require("../structure");
function isRenderingTextField(field) {
    return (0, structure_1.isTextFieldType)(field.type);
}
function isRenderingRadioField(field) {
    return field.type === fieldTypes_1.FieldTypes.radio;
}
function isRenderingCheckboxGroupField(field) {
    return field.type === fieldTypes_1.FieldTypes.checkboxGroup;
}
function isRenderingAgreeField(field) {
    return field.type === fieldTypes_1.FieldTypes.agree;
}
function isRenderingButtonField(field) {
    return field.type === fieldTypes_1.FieldTypes.button;
}
function isRenderingAutocompleteField(field) {
    return field.type === fieldTypes_1.FieldTypes.autocomplete;
}
function isRenderingPlaceholderField(field) {
    return !!field.placeholder;
}
function isRenderingOptionField(field) {
    return !lodash_1.default.isEmpty(field.options);
}
function isRenderingRepeatedSectionGroup(sectionGroup) {
    return lodash_1.default.get(sectionGroup, ['options', 'repeatable'], false);
}
function isRenderingRepeatedFieldGroup(fieldGroup) {
    return lodash_1.default.get(fieldGroup, ['options', 'repeatable'], false);
}
function isRenderingInformationField(field) {
    return field.type === fieldTypes_1.FieldTypes.information;
}
